// removed by extract-text-webpack-plugin
module.exports = {"wasabi-detail":"wasabi-detail","wasabi-table":"wasabi-table","table-container":"table-container","table-fixed":"table-fixed","table-realTable":"table-realTable","table":"table","page-select":"page-select","even":"even","selected":"selected","both":"both","asc":"asc","desc":"desc","pagination":"pagination","active":"active","wasabi-table-pagination":"wasabi-table-pagination","pagination-info":"pagination-info"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Data/DataGridDetail.scss
// module id = 172
// module chunks = 0